import _ from 'lodash';
import { Component, Input, Output, EventEmitter} from '@angular/core';
import { VesselMapModel, VesselService, OceanLineModel, AlertService, VesselModel, Oper} from 'app/services/index'
declare var $:any;

@Component({
  selector: 'vessel-map-detail',
  templateUrl: 'vessel-map-detail.html'
})
export class VesselMapDetailComponent {

    _vesselMapId:number;
    vesselMap:VesselMapModel = new VesselMapModel();

    @Input()operList:Array<Oper> = new Array();

    operTypeList:Array<any> = new Array<any>();
    stusList:Array<any> = new Array<any>();
    scraperTypeList:Array<any> = new Array<any>();
    
    @Output() onRefresh: EventEmitter<any> = new EventEmitter();
    @Output() onClose: EventEmitter<any> = new EventEmitter();

    @Input() vesselList:Array<VesselModel> = new Array();
    
    constructor(   
        private vesselService:VesselService,
        private alertService:AlertService
    ) {
    }

    @Input() set vesselMapId(vesselMapId){
        this.vesselMap = new VesselMapModel();
        this._vesselMapId = vesselMapId;
        if(vesselMapId != null) {
            this.getVesselMap(vesselMapId);
        }
        
    }

    ngOnInit() {
        this.initMake();
    }

    initMake(){
        this.operTypeList.push({text:'SHIP_OPERATOR', id:'0'});
        this.operTypeList.push({text:'TERMINAL', id:'1'});
        this.operTypeList.push({text:'FORWARDER', id:'2'});

        this.stusList.push({text:'REQUEST', id:'0'});
        this.stusList.push({text:'MAPPED', id:'1'});
        this.stusList.push({text:'SKIP', id:'2'});
        this.stusList.push({text:'TEMPMAPPED', id:'3'});
        this.stusList.push({text:'CHECK', id:'4'});
        this.stusList.push({text:'NONE', id:'5'});

        this.scraperTypeList.push({text:'P2P_SCHEDULE', id:'0'});
        this.scraperTypeList.push({text:'BERTH_PLAN', id:'1'});
        this.scraperTypeList.push({text:'LCL_SCHEDULE', id:'2'});
        this.scraperTypeList.push({text:'VESSEL_SCHEDULE', id:'3'});
        this.scraperTypeList.push({text:'AIR_SCHEDULE', id:'4'});
        this.scraperTypeList.push({text:'TRACKING', id:'5'});
    }

    getVesselMap(vesselMapId:number){
        this.vesselService.getVesselMap(vesselMapId).subscribe(
            res => {
                if(res.result) {
                    this.vesselMap = res.data;
                }
            }
        );
    }

    selecedOper(event:Oper) {
        if(event != null) {
            this.vesselMap.operCd = event.operCd;
            this.vesselMap.operTpCd = event.operTpCd;
            this.vesselMap.operTpNm = event.operTpNm;
        } else {
            this.vesselMap.operCd = null;
            this.vesselMap.operTpCd = null;
            this.vesselMap.operTpNm = null;
        }
    }

    selecedMapping(vessel:VesselModel){
        if(event != null) {
            this.vesselMap.vessel = vessel;
        } else {
            this.vesselMap.vessel = null;
        }
    }

    selected(values:any, type:string){
        if(type.indexOf('STATUS') > -1){
            this.vesselMap.vesselMapStatusCd = Number(values.id);
            this.vesselMap.vesselMapStatusNm = values.text;
        }else{
            this.vesselMap.reqSystemCd = Number(values.id);
            this.vesselMap.reqSystemNm = values.text;
        }
    }

    save(){
        let that = this;
        $.sweetModal.confirm('저장을 진행하시면 체크된 Vessel Map이 새로 고침 됩니다. 저장하시겠습니까?', function() {
            if(that.vesselMap.reqSystemCd == null || that.vesselMap.reqSystemCd == undefined){
                that.alertService.error("상태 코드는 필수 입니다. 상태 코드를 선택해주세요.");
                return ;
            }

            if(that.vesselMap.vesselMapStatusCd == null || that.vesselMap.vesselMapStatusCd == undefined){
                that.alertService.error("스크랩퍼 타입는 필수 입니다. 스크랩퍼 타입을 선택해주세요.");
                return ;
            }


            if(that.vesselMap.vesselMapId == null || that.vesselMap.vesselMapId == undefined) {
                that.vesselService.postVesselMap([that.vesselMap]).subscribe(
                    res =>{
                        if(res.result){
                            that.alertService.success("저장 되었습니다.");
                            that.onRefresh.emit(2);
                        }
                    }
                );                
            }else{
                if(that.vesselMap.vesselMapStatusCd == 1 && that.vesselMap.vessel == null) that.vesselMap.vesselMapStatusCd = 0;
                that.vesselService.patchVesselMap([that.vesselMap]).subscribe(
                    res =>{
                        if(res.result){
                            that.alertService.success("저장 되었습니다.");
                            that.onRefresh.emit(2);
                        }
                    }
                );    
            }

        }, function() {
        });
    }

    close(){
        this.onClose.emit();
    }
}





// WEBPACK FOOTER //
// ./src/app/containers/vessel/vessel-map-detail.ts